<template>
  <div class="pwd-container">
    <div style="text-align:justify">{{ $t("message.password_protected") }}</div>
    <div style="margin:2rem 0px;width:100%">
      <Password v-model="pwd" style="width:100%" :placeholder="$t('message.input_password')" :feedback="false" :toggleMask="true" :class="{'p-invalid': show_error }" @click="enterPwd()"/>
      <div v-if="show_error&&password_required" class="p-error">{{ $t("message.password_required") }}</div>
      <div v-if="show_error&&invalid_password" class="p-error">{{ $t("message.invalid_password") }}</div>
      <div v-if="show_error&&error_password" class="p-error">{{ $t("message.password_validation_error") }}</div>
    </div>
    <Button :label='$t("message.validate")' @click="checkPwd()" style="width:100%"/>
  </div>
</template>

<script>
import Password from 'primevue/password';
import Button from 'primevue/button';
import axios from 'axios';

export default {
  name: 'PwdPage',
  inject: ['dialogRef'],
  components: {
    Password,
    Button
  },
  data(){
    return {
      pwd:'',
      QR_STATUS_VALID:1,
      QR_STATUS_PWD_REQUIRED:-5,
      show_error:false,
      password_required:false,
      invalid_password:false,
      error_password:false
    }
  },
  props: {
  },
  methods:{
    checkPwd(){

        if(this.pwd.trim().length==0){

          this.password_required=true;

          this.invalid_password=false;

          this.error_password=false;

          this.show_error=true;

          return;

        }

        const _this=this;

        axios
        .post(this.$common.HOST+'/qr/view.html?key='+(this.$common.qr.key?this.$common.qr.key:'')+'&sk='+(this.$common.qr.sk?this.$common.qr.sk:''),{pwd:this.pwd, access_token:this.$common.access_token})
        .then(response => {

          _this.$common.qr.status=response.data.status;

            if(_this.$common.qr.status!=_this.QR_STATUS_PWD_REQUIRED) // password required
            {

              if(_this.$common.qr.status==_this.QR_STATUS_VALID){

                _this.$common.qr.type=response.data.qrcode.type;

                _this.$common.qr.roles=response.data.qrcode.roles;

                _this.$common.qr.qrjson=response.data.qrcode.qrjson;

                _this.$common.trademark=response.data.trademark;

                _this.$common.qr.srid=response.data.srid;

              }
                
              _this.dialogRef.close();
              
              //this.pwdresult=true;
            }
            else
            {

              _this.password_required=false;

              _this.invalid_password=true;

              _this.error_password=false;

              _this.show_error=true;

            }

        })
        .catch(() => {

          _this.password_required=false;

          _this.invalid_password=false;

          _this.error_password=true;
      
          _this.show_error=true;

        })

      
    },
    enterPwd(){

      this.show_error=false;

    }
  },
  created(){


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.pwd-container{
  height:100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding:1rem 3rem;
}
.pwd-container:last-child{
  margin-bottom: 0px;
}

</style>